import { create } from 'zustand';
// Removed TypeScript imports: import { TabState, TabInstance } from '../types/tab';
// import { TAB_CONFIG } from '../config/tabRegistry';
import { storeManager } from './storeManager';

export const useTabStore = create((set, get) => ({
  tabs: [],
  activeTabId: null,

  setTabs: (tabs) => {
    set({ tabs });
    // console.log(storeManager.stores)
  },

  addTab: (tabs, data = {}) => {
    set((state) => ({
      tabs: [...state.tabs, newTab],
      activeTabId: tabId
    }));
  },

  removeTab: (tabId, tabs, newTabId) => {
    // First, clear all store data associated with this tab
    storeManager.clearAllStoresForTab(tabId);

    // Then remove the tab from our store
    set({
      tabs: tabs,
      // If we're removing the active tab, set active to the last tab or null
      activeTabId: newTabId
    });
  },

  removeStoreForTab: (tabId) => {
    // Clear all store data associated with this tab
    storeManager.clearAllStoresForTab(tabId);
  },

  removeAllTabs: (currentTabId, newTabs, currentTabs) => {
    // Get all tab IDs except the current one
    const tabsToClose = currentTabs.filter((tab) => tab.id !== currentTabId);
    // console.log(`Tabs to close: ${tabsToClose.length}`, tabsToClose.map(t => t.id));
    storeManager.dumpTabStateCaches();

    // Instead of just updating the state once at the end, we'll actually call removeTab
    // for each tab, but modify it slightly to avoid changing the activeTabId
    const safeRemoveTab = (tabId) => {
      console.log(`Safe removing tab: ${tabId}`);

      // Use the same store clearing logic as removeTab
      storeManager.clearAllStoresForTab(tabId);

      // But only update the tabs array, not the activeTabId
      set((state) => ({
        ...state,
        tabs: state.tabs.filter((tab) => tab.id !== tabId)
      }));
    };

    // Close each tab one by one
    tabsToClose.forEach((tab) => {
      safeRemoveTab(tab.id);
    });

    storeManager.dumpTabStateCaches();

    console.log('closeAllTabsExceptCurrent completed');
    // Keep only the current tab's stores
    // storeManager.clearAllStoresExceptTab(currentTabId);
  },

  setActiveTab: (tabId) => {
    set({ activeTabId: tabId });
    // console.log(storeManager.stores);

    // Tell all stores to update their tab ID
    storeManager.updateStoresTabId(tabId);
  },

  // Add this method to generate unique tab instance IDs
  getTabInstanceId: (tabId, dataId) => {
    const tab = get().tabs.find((t) => t.id === tabId);
    if (!tab) return tabId;

    // For tabs with data (like project details), combine tab ID with data ID
    return dataId ? `${tab.tabType}:${dataId}` : tab.id;
  }
}));
